"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCreateEntityDialogTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCreateEntityDialogTitle = styled_components_1.default.div `
  && {
    justify-content: flex-start;
  }

  && .create-entity-dialog-title-text {
    flex: 0 1 auto;
  }
`;
